module.exports = __webpack_public_path__ + "img/BIDR_ikon.616540de.jpg";